export default "<app-invoices-list></app-invoices-list>";